<section class="profile-overview container mx-auto max-w-screen-md px-4 py-8">
  <div class="profile-overview__card shadow-box flex flex-col items-center gap-4 text-center">
    <h1 class="m-0">Dein Profil</h1>
    <p class="m-0">
      Hier findest du deine persönlichen Inhalte und Einstellungen (bald verfügbar).
    </p>

    <a routerLink="/profile/bookmarks" class="profile-overview__cta">
      Zu meinen gespeicherten Fragen
    </a>
  </div>

  <div class="mt-6 flex justify-center">
    <a (click)="logout()"
      class="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-950/40 transition-colors cursor-pointer">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      Abmelden
    </a>
  </div>
</section>
  
